import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { addFn } from 'api/tool/message';
import ueditor from '@/components/ueditor';
import { topConfig, btnConfig, mustReadConfig } from './config';
import selectDepTree from './select-dep-tree';
import department from '@/components/department';
export default {
  props: ['category'],
  components: {
    ueditor: ueditor,
    selectDepTree: selectDepTree,
    department: department
  },
  data: function data() {
    return {
      visible: false,
      topConfig: topConfig(this),
      btnConfig: btnConfig(this),
      mustReadConfig: mustReadConfig(this),
      form: {
        name: '',
        content: '',
        type: '1',
        ids: null,
        is_top: '0',
        // 默认不置顶
        must_read: '0' // 打开时 是否必读
      },

      dataRule: {
        name: [{
          required: true,
          message: this.$t('867')
        }],
        content: [{
          required: true,
          message: this.$t('867')
        }],
        ids: [{
          required: true,
          message: this.$t('221')
        }]
      },
      disabled: false,
      isSelectDepTree: false
    };
  },
  methods: {
    init: function init() {
      var _this = this;
      this.visible = true;
      this.$nextTick(function () {
        return _this.$refs.dataForm.clearValidate();
      });
    },
    showDeepTree: function showDeepTree() {
      var _this2 = this;
      this.isSelectDepTree = true;
      this.$nextTick(function () {
        return _this2.$refs.selectDepTree.init();
      });
    },
    departmentHandle: function departmentHandle(val1, val2) {
      this.form.ids = _toConsumableArray(new Set(val2.flat(999999))).join(',');
    },
    submit: function submit() {
      var _this3 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this3.disabled = true;
          addFn(_objectSpread(_objectSpread({}, _this3.form), {}, {
            category: _this3.category
          })).then(function (res) {
            _this3.disabled = false;
            if (res && res.code === 1) {
              _this3.visible = false;
              _this3.$emit('refreshTableList');
            }
          }).finally(function () {
            return _this3.disabled = false;
          });
        }
      });
    }
  },
  watch: {
    visible: function visible(val) {
      if (!val) this.$refs.dataForm.resetFields();
    },
    'form.type': function formType() {
      this.form.ids = null;
    }
  }
};